export default __webpack_public_path__ + "5e7ae011d4dd007e6fe643776a9d723d.png";